import axios from "axios";
import { BASE_URL, AXIOS_TIMEOUT } from "@/utilities/configurations";
import axiosInterceptor from "./interceptors/interceptor";
import storageService from "./storageService";
import { useNetworkStatusStore } from "@/zustand/networkStatusStore";
import { useUsersStore } from "@/zustand/usersStore";
import { FT_NAME } from "@/components/routes/feature-access/featureAccessResolver";

const client = axios.create({
  baseURL: BASE_URL,
  timeout: AXIOS_TIMEOUT,
});

client.defaults.headers.common["Content-Type"] = "application/json";

client.interceptors.request.use((config) => {
  const userToken = storageService.getItem("token");

  if (userToken) {
    config.headers.Authorization = userToken;
  }

  const { accountFeatures } = useUsersStore.getState().user;
  const hasSensorFirewall = accountFeatures?.some(
    (el) => el.name === FT_NAME.SENSOR_FIREWALL
  );
  if (!hasSensorFirewall) {
    const selectedSensor = storageService.getItem("sensor") ?? null;
    config.headers["opt-sensor"] = selectedSensor;
  }

  return config;
});

client.interceptors.response.use(
  (response) => {
    if (useNetworkStatusStore.getState().isNetworkDown) {
      useNetworkStatusStore.getState().setNetworkUp();
    }
    return axiosInterceptor.responseSuccess(response);
  },
  (error) => {
    const config = error.config;

    // Show overlay on network errors (no response) for GET requests
    const isNetworkError =
      !error.response &&
      config &&
      config.method === "get" &&
      !axios.isCancel(error) &&
      error.code !== "ERR_CANCELED";

    if (isNetworkError) {
      // Silently ignore network errors for non-critical endpoints
      if (config.url?.includes("/alerts")) {
        return Promise.reject(error);
      }

      useNetworkStatusStore.getState().setNetworkDown();
    }

    return axiosInterceptor.responseError(error);
  }
);

export default client;
